import { outter_post,post } from 'common/js/axios-helper';
import { OnlineApi } from "./constant/UrlMapper";

const host = "8880";
const host3 = "8883"


const onlineapplicationcardresourcesList = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardResourcesList, data, host);
};
const onlineapplicationcardresourcessync = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardResourcesSync, data, host);
};

const onlineapplicationcardmanageList = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardManageList, data, host);
};
const onlineapplicationcardmanageUpdate = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardManageUpdate, data, host);
};
const onlineapplicationcardmanageInsert = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardManageInsert, data, host);
};
const onlineapplicationcardmanageStatus = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardManageStatus, data, host);
};
const onlineapplicationcardmanageJd = (data) => {
    return outter_post(OnlineApi.OnlineApplicationCardManageJd, data, host);
};

const meronlineapplicationcardmanageList = (data) => {
    return outter_post(OnlineApi.MerOnlineApplicationCardManageList, data, host);
};
const meronlineapplicationcardmanageUpdate = (data) => {
    return outter_post(OnlineApi.MerOnlineApplicationCardManageUpdate, data, host);
};
const meronlineapplicationcardmanageInsert = (data) => {
    return outter_post(OnlineApi.MerOnlineApplicationCardManageInsert, data, host);
};
const meronlineapplicationcardmanageStatus = (data) => {
    return outter_post(OnlineApi.MerOnlineApplicationCardManageStatus, data, host);
};
const meronlineapplicationcardmanageJd = (data) => {
    return outter_post(OnlineApi.MerOnlineApplicationCardManageJd, data, host);
};

const onlinecardresultList = (data) => {
    return outter_post(OnlineApi.OnlineCardResultList, data, host);
};
const onlinecardList = (data) => {
    return post(OnlineApi.OnlineCard, data, host3);
};
const onlinecardresultLook = (data) => {
    return outter_post(OnlineApi.OnlineCardResultLook, data, host);
};

export default {
    onlineapplicationcardresourcesList,
    onlineapplicationcardresourcessync,

    onlineapplicationcardmanageList,
    onlineapplicationcardmanageUpdate,
    onlineapplicationcardmanageInsert,
    onlineapplicationcardmanageStatus,
    onlineapplicationcardmanageJd,

    meronlineapplicationcardmanageList,
    meronlineapplicationcardmanageUpdate,
    meronlineapplicationcardmanageInsert,
    meronlineapplicationcardmanageStatus,
    meronlineapplicationcardmanageJd,

    onlinecardresultList,
    onlinecardresultLook,
    onlinecardList
}



// WEBPACK FOOTER //
// ./src/service/OnlineService.js